import types from './types'
import { CachedUserInfo } from '@/services/CachedStorages'

export default {
  state: {
    info: {
      block_id: '',
      block_name: '',
      name: '',
      perms: {},
      staff_id: '',
      staff_no_prefix: '',
      csrftoken: ''
    }
  },

  getters: {
    perms: state => state.info.perms,
    avatarText: state => `${state.info.block_name}-${state.info.name}`
  },

  mutations: {
    [types.SAVE](state, data) {
      if (data) {
        CachedUserInfo.set(data)
      }
      state.info = data
    },

    [types.DELETE](state) {
      state.info = {}
      CachedUserInfo.remove()
    }
  },

  actions: {
    [types.SAVE]({commit}, data) {
      commit(types.SAVE, data)
    },

    [types.DELETE]({commit}) {
      commit(types.DELETE)
    }
  }
}
